import { useEffect, useState } from "react";
import { api } from "../lib/api";

export function ChatPolicy() {
  const [policy, setPolicy] = useState(null);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  useEffect(() => {
    let active = true;
    api.getChatPolicy().then(value => { if (active) setPolicy(value); })
      .catch(() => { if (active) setError("Chat policy could not be loaded. No settings were changed."); });
    return () => { active = false; };
  }, []);
  async function togglePolicy() {
    setSaving(true); setError(""); setSaved(false);
    try { setPolicy(await api.updateChatPolicy(!policy.general_enabled)); setSaved(true); }
    catch (err) { setError(`Policy was not saved: ${err.message}`); }
    finally { setSaving(false); }
  }
  return <section className="account-summary" aria-labelledby="chat-policy-title">
    <h2 id="chat-policy-title">AI answer policy</h2>
    <p>Workspace Knowledge is the default. General Assistant uses the deployment’s configured model without retrieving workspace documents. It does not browse the web or inspect live infrastructure.</p>
    {policy ? <>
      <p role="status">General Assistant: <strong>{policy.general_enabled ? "Enabled" : "Disabled"}</strong>{saved ? " · Saved" : ""}</p>
      {policy.can_manage ? <button type="button" className="btn btn-outline" disabled={saving} onClick={togglePolicy}>
        {saving ? "Saving…" : policy.general_enabled ? "Disable General Assistant" : "Enable General Assistant"}
      </button> : <p>Only a workspace owner or administrator signed in with a user session can change this policy.</p>}
    </> : !error && <p role="status">Loading chat policy…</p>}
    {error && <p role="alert">{error}</p>}
  </section>;
}
